// extracted by mini-css-extract-plugin
export default {"link":"card_link__7Ptw0","card":"card_card__zPn8z","icon":"card_icon__4URyA"};